"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domReady = void 0;

var domReady = function domReady(callback) {
  if (['interactive', 'complete'].includes(document.readyState)) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

exports.domReady = domReady;